import { useState } from "react";
import { Calendar, Clock, User } from "lucide-react";
import { resolveApiImageUrl } from "../../../utils/imageUrl";

const SessionCard = ({ session }) => {
  const [imageFailed, setImageFailed] = useState(false);
  const tutorName = session.tutorName || session.tutor || "Tutor";
  const imageSrc = imageFailed ? "" : resolveApiImageUrl(session.image);
  const avatarLetter = tutorName.charAt(0).toUpperCase() || "T";
  const isUpcomingSession = session.status === "Upcoming";
  const isPendingSession = session.status === "Pending";
  const statusClassName = isUpcomingSession
    ? "bg-green-50 text-green-600"
    : isPendingSession
      ? "bg-amber-50 text-amber-700"
      : "bg-gray-100 text-gray-600";

  return (
    <div className="bg-white rounded-3xl shadow-sm border border-gray-200 p-8 flex items-center w-full">
      {imageSrc ? (
        <img
          src={imageSrc}
          alt={tutorName}
          className="w-40 h-40 rounded-3xl object-cover"
          onError={() => setImageFailed(true)}
        />
      ) : (
        <div className="w-40 h-40 rounded-3xl bg-[#eef3ff] text-[#2f4fd6] flex items-center justify-center text-5xl font-bold">
          {avatarLetter}
        </div>
      )}

      <div className="ml-10 flex min-w-0 flex-1 flex-col gap-3 items-start">
        <div className="flex flex-col">
          <div className="flex items-center gap-3">
            <p className="text-xl font-semibold text-gray-900">
              {tutorName}
            </p>

            <span className={`px-5 py-1.5 rounded-full text-sm font-medium ${statusClassName}`}>
              {session.status}
            </span>

            {session.actionLabel && typeof session.onAction === "function" ? (
              <button
                type="button"
                onClick={session.onAction}
                disabled={Boolean(session.actionDisabled)}
                className="rounded-full border border-[#0736D6] px-4 py-1.5 text-sm font-semibold text-[#0736D6] transition hover:bg-[#0736D6] hover:text-white disabled:cursor-not-allowed disabled:opacity-50"
              >
                {session.actionLabel}
              </button>
            ) : null}
          </div>
        </div>

        <div className="grid w-full grid-cols-1 gap-6 md:grid-cols-3">
          <div className="flex items-center gap-3 min-w-0">
            <Calendar size={20} strokeWidth={2} className="text-teal-500" />

            <div className="min-w-0">
              <span className="block whitespace-nowrap text-base text-gray-500">Date</span>
              <p className="text-lg font-normal text-gray-900">
                {session.date}
              </p>
            </div>
          </div>

          <div className="flex items-center gap-3 min-w-0">
            <Clock size={20} strokeWidth={2} className="text-teal-500" />

            <div className="min-w-0">
              <span className="block whitespace-nowrap text-base text-gray-500">Time</span>
              <p className="text-lg font-normal text-gray-900">
                {session.time}
              </p>
            </div>
          </div>

          <div className="flex items-center gap-3 min-w-0">
            <User size={20} strokeWidth={2} className="text-teal-500" />

            <div className="min-w-0">
              <span className="block whitespace-nowrap text-base text-gray-500">
                {session.personLabel || "Student"}
              </span>
              <p className="text-lg font-normal text-gray-900">
                {session.studentName || session.student}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default SessionCard
